module.exports = __webpack_public_path__ + "img/in_transaction1.33ec6be1.svg";